import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';
import {staggeredReveal} from '../../css/styleSets';
import {FeatureSelectItem} from './featureSelectItem';
import {pimText} from '../../util/values';

@customElement('feature-assistant-list-select-item')
export class FeatureAssistantListSelectItem extends FeatureSelectItem {

	@property({type: Boolean})
	hideDisabled = false

	static styles = [
		staggeredReveal,
		css`
			:host {
			}

			.item {
				background: var(--color-widget-background);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: column;
				gap: 10px;
				padding: 16px;
				cursor: pointer;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
			}
			.item.selected {
				background: var(--color-widget-background-selected-dark);
			}
			.item:hover {
				background: var(--color-widget-background-hover);
			}
			.item.selected:hover {
				background: var(--color-widget-background-selected-dark);
			}
			.label {
				font: var(--font-widget-big-label);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: row;
				position: relative;
				justify-content: space-between;
			}
			.labeltext {

			}
			.icon {

			}
			.description {
				font: var(--font-widget-info);
				color: var(--color-widget-info);
				line-height: 1.4;
				opacity: 0;
				animation: reveal 0.25s ease-out 0s 1 normal forwards;
			}
			@keyframes reveal {
				from {
					opacity: 0;
				}

				to {
					opacity: 100%;
				}
			}

			.selected button {
				color: var(--color-text-widget-active);
				border: var(--border-widget-active);
				background-color: var(--color-background-widget-active);
			}

			.fixed button {
				border: var(--border-widget-fixed);
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-grey6);
				border-color: var(--color-grey6);
				pointer-events: none;
			}

			.disabled button:hover {
				color: var(--color-white);
			}

			.disabled.hideDisabled button {
				display: none
			}

			.icon {
				display: inline-block;
			}

			.icon svg {
				display: block;
			}
        `];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		return html`
			<div class="item ${classMap({
				selected: this.isIncluded(),
				disabled: !this.canBeIncluded(),
				hideDisabled: this.hideDisabled,
				fixed: !this.canBeExcluded()
			})}" @click="${this.toggleDecision}">
				<div class="label">
					<div class="labeltext"><trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV"></trans-label></div>

					${when(this.isIncluded(),
						() => html`
							<div class="icon">${radioChecked}</div>`,
						() => html`
							<div class="icon">${radio}</div>`,)
					}
				</div>
				${when(this.isIncluded() && pimText(this.lang, this.featureValue.featureId, 'FV.D', this.decisions, this.translations, this.featureValue.featureValueId) !== '', () => html`
					<div class="description">
						<trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV.D"></trans-label>
					</div>
				`)}

			</div>
        `;
	}
}
